export const freeze = (ms: number) => {
  return new Promise((resolve) => setTimeout(resolve, ms))
}

export const debounce = <T extends any[]>(
  func: (...args: T) => void,
  ms: number
) => {
  let timeout: ReturnType<typeof setTimeout> | null = null
  return (...args: T) => {
    if (timeout) {
      clearTimeout(timeout)
    }
    timeout = setTimeout(() => func(...args), ms)
  }
}
